var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound"},[_c('img',{attrs:{"src":require("@/assets/img/image-notfound.png"),"alt":""}}),_c('button',{staticClass:"btn",on:{"click":_vm.goToHome}},[_vm._v("Got to Home Page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }